<template>
  <div>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true" :text="uploadMsg">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>
    <b-row>
      <b-col cols="12" lg="12">
        <b-card no-header>
          <template slot="header">Edit User</template>
          <b-row class="justify-content-md-center">
            <b-col cols="12" md="8">
              <b-form @submit.prevent="handleSubmit(inputcheck)">
                <b-row>
                  <b-col cols="12" md="6">
                    <div :class="{error: validation.hasError('name')}">
                      <b-form-group label="Name *">
                        <b-form-input
                          v-model="name"
                          type="text"
                          id="name"
                          placeholder="Name"
                          required
                        ></b-form-input>
                        <template slot="description" v-if="validation.firstError('name')">
                          <span style="color:red;">{{validation.firstError('name')}}</span>
                        </template>
                      </b-form-group>
                    </div>
                  </b-col>
                  
                  <b-col cols="12" md="6">
                    <!-- <div :class="{error: validation.hasError('username')}"> -->
                      <b-form-group label="Username ">
                        <b-form-input
                          v-model="username"
                          type="text"
                          id="username"
                          placeholder="username"
                        ></b-form-input>
                        <!-- <template slot="description" v-if="validation.firstError('username')">
                          <span style="color:red;">{{validation.firstError('username')}}</span>
                        </template> -->
                      </b-form-group>
                    <!-- </div> -->
                  </b-col>
                  
                  <b-col cols="12" md="6">
                    <div :class="{error: validation.hasError('phone')}">
                      <b-form-group label="Phone No *">
                        <b-form-input
                          v-model="phone"
                          type="number"
                          id="phone"
                          placeholder="Phone Number"
                        ></b-form-input>
                        <template slot="description" v-if="validation.firstError('phone')">
                          <span style="color:red;">{{validation.firstError('phone')}}</span>
                        </template>
                      </b-form-group>
                    </div>
                  </b-col>
                  <b-col cols="12" md="6">
                    <!-- <div :class="{error: validation.hasError('email')}"> -->
                      <b-form-group label="Email ">
                        <b-form-input v-model="email" type="email" id="email" placeholder="Email"></b-form-input>
                        <!-- <template slot="description" v-if="validation.firstError('email')">
                          <span style="color:red;">{{validation.firstError('email')}}</span>
                        </template> -->
                      </b-form-group>
                    <!-- </div> -->
                  </b-col>
                  <b-col cols="12" md="6">
                    <div :class="{error: validation.hasError('role')}">
                      <b-form-group label="Role">
                        <b-form-select
                          :disabled="userRole=='Manager'?true:false"
                          v-model="role"
                          :options="userTypes"
                        ></b-form-select>
                        <template slot="description" v-if="validation.firstError('role')">
                          <span style="color:red;">{{validation.firstError('role')}}</span>
                        </template>
                      </b-form-group>
                    </div>
                  </b-col>
                  <b-col v-if="role!='SuperUser'" cols="12" md="6">
                    <b-form-group label="Division *">
                      <b-form-select
                        v-model="division"
                        :disabled="userRole=='Manager'?true:false"
                        :options="divisions"
                        text-field="name"
                        value-field="_id"
                      ></b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col v-if="role=='Informant' || role=='Subscriber'" cols="12" md="6">
                    <b-form-group label="Range *">
                      <b-form-select
                        v-model="range"
                        :options="ranges"
                        text-field="name"
                        value-field="_id"
                      ></b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form>
            </b-col>
          </b-row>
          <b-row class="py-2 justify-content-md-center text-center">
            <b-col cols="12">
              <img v-if="newImage" :src="newImage" width="auto" height="150px" />
            </b-col>
          </b-row>
          <b-row class="py-2 justify-content-md-center">
            <b-col cols="12" md="6">
              <b-form-group label="Add User Image">
                <b-form-file id="fileInput" :plain="false" v-model="image" @change="showImage"></b-form-file>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="py-2 justify-content-md-center">
            <span style="color:red">{{msg}}</span>
          </b-row>
          <b-row class="justify-content-center">
            <div class="px-2">
              <b-button variant="outline-primary" size="sm" @click.prevent="inputCheck">Submit</b-button>
            </div>
          </b-row>
          <template slot="footer">
            <b-button @click="$router.go(-1)" size="sm">Back</b-button>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ServerError: false,
      appLoading: false,
      msg: null,
      userTypes: [
        "SuperUser",
        "Researcher",
        "Manager",
        "Informant",
        "Subscriber",
      ],
      name: null,
      
      username: null,
      phone: null,
      email: null,
      designation: null,
      role: "Researcher",
      division: null,
      range: null,
      divisions: [],
      ranges: [],
      image: null,
      uploadMsg: "",
      newImage: null,
      userRole: localStorage.getItem("role"),
    };
  },
  beforeMount() {
    this.getData();
  },
  watch: {
    division(newvalue, oldvalue) {
      if (oldvalue != null && newvalue != oldvalue) {
        this.range = null;
      }
      this.getRanges(this.division);
    },
  },
  validators: {
    name(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .regex("^[a-zA-Z ]+$", "Name can only use Letters")
        .minLength(3, "Minimum 3 Characters Needed");
    },
    // username(value) {
    //   return this.Validator.value(value)
    //     .required("Required Field")
    //     .regex(
    //       "^[a-z0-9_.-]*$",
    //       "Usernames can only use lowercase letters, numbers, underscores and periods."
    //     );
    // },
    phone(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .regex("^(?=.*[0-9])", "Please Input Valid Number.");
    },
    // email(value) {
    //   return this.Validator.value(value).required("Required Field").email();
    // },
    role(value) {
      return this.Validator.value(value).required("Required Field");
    },
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        url: "/user/get",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          id: this.$route.params.id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          var user = response.data.data;
          this.name = user.name;
          
          this.username = user.username;
          this.designation = user.designation;
          this.phone = user.phone;
          this.email = user.email;
          this.role = user.role;
          if (user.division) {
            this.division = user.division._id;
          }
          if (user.range) {
            this.range = user.range._id;
          }
          this.getDivisions();
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    getDivisions() {
      this.appLoading = true;
      axios({
        url: "/division/getlist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          count: 0,
          page: 0,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.divisions = response.data.data;
          if (this.division == null) this.division = this.divisions[0]._id;
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    getRanges(item) {
      this.appLoading = true;
      axios({
        url: "/range/getlist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          count: 0,
          page: 0,
          division: item,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.ranges = response.data.data;
          if (this.ranges.length < 1) {
            if (this.role == "Informant" || this.role == "Subscriber") {
              this.msg = "Please Add a range to the selected Division";
              return;
            }
          } else {
            if (this.range == null) this.range = this.ranges[0]._id;
            this.msg = null;
          }
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    inputCheck() {
      this.msg = null;
      this.$validate().then((success) => {
        if (success) {
          this.editUser();
        } else {
          this.msg = "Please validate input fields";
          return;
        }
      });
    },
    editUser() {
      this.appLoading = true;
      var user = {};
      user["id"] = this.$route.params.id;
      user["name"] = this.name;
     
      user["username"] = this.username;
      user["phone"] = this.phone;
      user["designation"] = this.designation;
      user["email"] = this.email;
      user["role"] = this.role;
      if (this.role != "SuperUser") {
        user["division"] = this.division;
      }
      if (this.role == "Informant" || this.role == "Subscriber") {
        user["range"] = this.range;
      }
      axios({
        method: "POST",
        url: "/user/adminedit",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: user,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            if (this.image) {
              this.uploadImage();
            } else {
              this.$router.go(-1);
            }
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },
    showImage(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        this.newImage = null;
        return;
      }
      if (files[0].size > 5242880) {
        this.msg = "File size Should be less than 5MB";
        return;
      } else {
        this.msg = null;
      }
      var reader = new FileReader();
      reader.onload = (e) => {
        this.newImage = e.target.result;
      };
      reader.readAsDataURL(files[0]);
    },
    uploadImage() {
      var vm = this;
      if (!this.image) {
        this.msg = "Please Upload an Image ";
        this.showSnackBar = true;
      } else {
        this.appLoading = true;
        let formData = new FormData();
        formData.append("id", this.$route.params.id);
        formData.append("photo", this.image);
        axios({
          method: "POST",
          url: "/user/adminphoto",
          headers: {
            "Content-Type": "multipart/form-data",
            "x-auth-token": localStorage.getItem("token"),
          },
          data: formData,
          onUploadProgress: function (progressEvent) {
            var percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            vm.uploadMsg = "Uploading " + percentCompleted + "%";
            // if (percentCompleted == 100) vm.uploadMsg = "";
          },
        })
          .then((response) => {
            this.appLoading = false;
            this.$router.go(-1);
          })
          .catch((err) => {
            this.ServerError = true;
          });
      }
    },
  },
};
</script>
